// @see https://www.twilio.com/en-us/blog/capturing-twilio-video-js-sdk-logs
import Video from 'twilio-video'
import { getRole } from '../../../global/roomInfo/roomInfo'
import { logBreadcrumb, logMessage } from '../../../Logging/sentry'

type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'silent'

const getSentryLevel = (level: LogLevel) => {
  switch (level) {
    case 'info':
    case 'error':
      return level
    case 'warn':
      return 'warning'
    case 'trace':
    case 'silent':
    case 'debug':
    default:
      return 'debug'
  }
}

const initialized = false

const initLogging = () => {
  if (initialized) return

  const logger = Video.Logger.getLogger('twilio-video')

  logger.methodFactory = (_methodName, _level, _loggerName) => {
    return (datetime, logLevel: LogLevel, component, message, data) => {
      const level = getSentryLevel(logLevel)

      if (logLevel === 'error') {
        logMessage(`Twilio — ${message}`, { level, extra: { component, data } })
      } else {
        logBreadcrumb(
          {
            message: `Twilio — ${message}`,
            category: 'Twilio',
            level,
            type: 'debug',
            timestamp: datetime,
          },
          { component, data }
        )
      }

      if (
        getRole() === 'headless' &&
        'relayDebugLog' in window &&
        typeof window.relayDebugLog === 'function'
      ) {
        window.relayDebugLog?.(
          `Twilio [${logLevel}] — ${message} ${component}`,
          data
        )
      }
    }
  }

  logger.setLevel(getRole() === 'headless' ? 'debug' : 'warn')
}

export { initLogging }
